import { useListContext, useResourceContext } from 'react-admin';
import { useExpandSignificantRows } from '@/composables/useExpandSignificantRows.js';

export const ExpandSignificantParameters = () => {
    const { data } = useListContext();
    const resource = useResourceContext();
    useExpandSignificantRows(resource, data);

    return null;
};
